import '../partials/common/certificates-slider/certificates-slider';
